var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLegendPatientEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H9C10.1046 1 11 1.89543 11 3V9C11 10.1046 10.1046 11 9 11H3C1.89543 11 1 10.1046 1 9V3Z",
    fill: "#426AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C5.5875 6 5.23438 5.85312 4.94062 5.55937C4.64687 5.26562 4.5 4.9125 4.5 4.5C4.5 4.0875 4.64687 3.73438 4.94062 3.44063C5.23438 3.14688 5.5875 3 6 3C6.4125 3 6.76562 3.14688 7.05937 3.44063C7.35312 3.73438 7.5 4.0875 7.5 4.5C7.5 4.9125 7.35312 5.26562 7.05937 5.55937C6.76562 5.85312 6.4125 6 6 6ZM3 9V7.95C3 7.7375 3.05475 7.54213 3.16425 7.36387C3.27375 7.18563 3.419 7.04975 3.6 6.95625C3.9875 6.7625 4.38125 6.61713 4.78125 6.52012C5.18125 6.42313 5.5875 6.37475 6 6.375C6.4125 6.375 6.81875 6.4235 7.21875 6.5205C7.61875 6.6175 8.0125 6.76275 8.4 6.95625C8.58125 7.05 8.72662 7.186 8.83612 7.36425C8.94562 7.5425 9.00025 7.73775 9 7.95V9H3Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegendPatientEvent);
export default __webpack_public_path__ + "static/media/icon-legend-patient-event.ea05c1f77b2d58a90a7bd1718f2056e4.svg";
export { ForwardRef as ReactComponent };